import { render, staticRenderFns } from "./ComparisonOnline.vue?vue&type=template&id=0b313464&scoped=true"
import script from "./ComparisonOnline.vue?vue&type=script&lang=ts"
export * from "./ComparisonOnline.vue?vue&type=script&lang=ts"
import style0 from "./ComparisonOnline.vue?vue&type=style&index=0&id=0b313464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b313464",
  null
  
)

export default component.exports